import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";


export const termsData: any = [
    {
      title: "Formation of Contract",
      content: (
        <div>
          <p>
            Submitting an order on our website concludes a contract for us to
            provide you with Services, and you to pay for those Services, on
            these Terms. Submitting an order will be deemed as acceptance of
            these Terms despite anything that may be stated to the contrary in
            your enquiries or your order. Submitting an order will be deemed as
            an acceptance to our declaration of <strong>What We Convert</strong> and{" "}
            <strong>What We Don't Convert</strong> in the FAQ section of our website.
          </p>
        </div>
      ),
    },
    {
      title: "Provision of Services",
      content: (
        <div>
          <ul>
            <li>
              MMC will perform the Services with reasonable care and skill,
              using suitably qualified and experienced personnel.
            </li>
            <li>
              MMC will make every effort to ensure delivery of Services within a
              reasonable time. However, we shall not be liable to you for any
              failure to deliver on a specified date or within a specified
              period.
            </li>
            <li>
              MMC cannot commence the Services until we have received a proper
              order and obtained access to the relevant financial data.
            </li>
            <li>
              MMC requires access to both the source software and the
              destination software, each with active subscriptions. Therefore,
              we will be unable to perform conversions for accounts with expired
              subscriptions or those on trial subscriptions.
            </li>
          </ul>
        </div>
      ),
    },
    {
      title: "Price and payment",
      content: (
        <div>
          <ul>
            <li>
              The price for the Services is as specified on our website for
              customers in your location at the time of your order. Unless
              stated otherwise on our website, the prices are in US Dollars.
            </li>
            <li>
              Payment will be considered to have been made only when irrevocable
              cleared funds have been received into our bank account through the
              payment processing gateway which we use at that time on our
              website.
            </li>
            <li>
              The prices specified include all types of taxes made applicable by
              Indian Government. If you are not based in India, you will be
              responsible for any government duties, levies or taxes which may
              be applicable in your jurisdiction
            </li>
            <li>
              Payment(s) through this Service may only be made with a Credit
              Card, Debit card or Net Banking.
            </li>
            <li>
              Before using this Service, it is recommended that the user shall
              make necessary enquiry about the charges or fees payable against
              the Credit/Debit card used from Credit Card or the Debit Card
              service provider i.e. the respective Bank.
            </li>
            <li>
              The credit card information supplied at the time of using the
              service is processed by the payment gateway of the service
              provider and is not supplied to MMC Convert. It is the sole
              responsibility of the User of the service to ensure that the
              information entered in the relevant fields are correct. It is
              recommended that you take and retain a copy of the transaction for
              record keeping purposes, which might assist in resolution of any
              disputes that may arise out or usage of the service
            </li>
            <li>
              The User agrees, understands and confirms that his/ her personal
              data including without limitation details relating to debit card/
              credit card/net banking transmitted over the Internet may be
              susceptible to misuse, hacking, theft and/ or fraud and that IITR
              or the Payment Service Provider(s) have no control over such
              matters.
            </li>
            <li>
              The User agrees that MMC Convert or any of its employees will not
              be held liable by the user for any loss or damages arising from
              failure to comply with these Terms and Conditions or where a
              failure is due to circumstance beyond MMC Convert’s reasonable
              control.
            </li>
            <li>
              The User may pay his/ her fee to MMC Convert by using a
              debit/credit card or through online banking account. The user
              warrants, agrees and confirms that when he/ she initiates a
              payment transaction and/or issues an online payment instruction
              and provides his/ her card/bank details:
              <p>
                The User is fully and lawfully entitled to use such credit/debit
                card, bank account for such transactions;
              </p>
              <p>
                The User is responsible to ensure that the card/bank account
                details provided by him/her are accurate;
              </p>
              <p>
                The User authorizes debit of the nominated card/bank account for
                the selected payment such User along with the applicable Fees.
              </p>
              <p>
                The User is responsible to ensure that sufficient credit is
                available on the nominated card/bank account at the time of
                making the payment to permit the Payment of the dues payable or
                fees dues selected by the User inclusive of the applicable Fee.
              </p>
            </li>
            <li>
              In case the accounting software to which you are converting is
              incurring the cost of the migration for you, the above points does
              not apply to you.
            </li>
          </ul>
        </div>
      ),
    },
    {
      title: "Ownership of Data and IP",
      content: (
        <div>
          <ul>
            <li>
              Nothing in these Terms affects :
              <ul>
                <li>your ownership of your data (and modifications to it);</li>
                <li>your ownership of your Pre-Existing IP; or</li>
                <li>our ownership of our Pre-Existing IP.</li>
              </ul>
            </li>
            <li>
              All IP in any Product, and all IP otherwise developed by MMC in
              performance of the Services, and any alterations, additions or
              amendments to that IP, shall be our property.
            </li>
            <li>
              You must ensure you have appropriate licenses in place for your
              accounting software so MMC can perform the Services.
            </li>
            <li>
              You must maintain your own backup copies of all data you provide
              to us. MMC will adhere to best practice policies and procedures to
              prevent data loss, but we do not make any guarantees that there
              will be no loss of data.
            </li>
            <li>
              By using our Services, you agree that we can use your data file
              for conversion purpose. When you upload or otherwise submit
              content to our Services, you give us (and those who work with us)
              a worldwide license to use, host, store, reproduce, modify, create
              derivative works (such as those resulting from translations,
              adaptations or other changes we make so that your content works
              better with our Services) The rights you grant are for the limited
              purpose of CONVERSION, thus you agree to ensure that you have the
              necessary rights to grant us this license for any content that you
              submit to our services.
            </li>
          </ul>
        </div>
      ),
    },
    {
      title: "Cancellation and Suspension",
      content: (
        <div>
          <ul>
            <li>
              You are not entitled to cancel an order for Services once
              submitted, except under clause{" "}
            </li>
            <li>
              MMC may cancel an order for Services at any time before the close
              of business on our third business day after receiving the order,
              if for any reason we consider that we cannot perform the Services.
              If we do this, we will advise you and any payment taken for the
              Services will be refunded less any bank charges incurred.
            </li>
            <li>
              Either party may terminate these Terms immediately by written
              notice to the other party if the other party :
              <ul>
                <li>
                  is in material breach of any of its obligations under these
                  Terms and either that breach is incapable of remedy, or that
                  other party has failed to remedy that breach within 15 days
                  after receiving written notice requiring it to do so; or is
                  unable to pay its debts, or becomes insolvent, or is subject
                  to an order or a resolution for its liquidation,
                  administration, winding-up or dissolution (otherwise than for
                  the purposes of a solvent amalgamation or reconstruction), or
                  has an administrative or other receiver, manager, trustee,
                  liquidator, administrator or similar officer appointed over
                  all or any substantial part of its assets, or enters into or
                  proposes any composition or arrangement with its creditors
                  generally, or is subject to any analogous event or proceeding
                  in any applicable jurisdiction.
                </li>
              </ul>
            </li>
            <li>
              On termination of these Terms, we shall without delay deliver to
              you all copies of information or data provided by you to us
              existing at the date of such termination, whether or not the
              Services are then complete.
            </li>
            <li>
              Fees once paid will not be refunded under any circumstances.
            </li>
          </ul>
        </div>
      ),
    },
    {
      title: "Limitation of liability",
      content: (
        <div>
          <ul>
            <li>
              In performing the Services we will not be liable for :
              <ul>
                <li>
                  Any data migration errors which are caused by the quality of
                  the source data which we obtain from you;
                </li>
                <li>
                  Any indirect or consequential loss or damage, any loss of
                  profit, loss of revenue, loss of business opportunities, loss
                  of data or loss of goodwill arising out of or in connection
                  with the Services or these Terms (whether or not the loss or
                  damage may have been in the contemplation of the parties as a
                  probable result of any act or omission); or
                </li>
                <li>
                  Breach of any warranties, representations, conditions or
                  obligations imposed or implied by law, statute or otherwise in
                  relation to the Services, which are capable of exclusion (to
                  the intent that to the maximum extent permitted by law, these
                  are hereby excluded).
                </li>
              </ul>
            </li>
            <li>
              Despite any other provision of these Terms, in no event, will our
              liability exceed the price of the Services ordered.
            </li>
          </ul>
        </div>
      ),
    },
    {
      title: "Privacy",
      content: (
        <div>
          <ul>
            <li>
              We respect your privacy and the confidentiality of your data. We
              will not send you spam emails
            </li>
            <li>
              MMC will take all reasonable steps to ensure that your privacy is
              not compromised.
            </li>
            <li>
              By providing email address, telephone numbers and other contact
              information, you agree that MMC Convert may contact by one or more
              of the modes of communications.
            </li>
            <li>
              The access to the information provided through the MMC Convert's
              website would only be given to authorized employees or other MMC
              Convert Group Companies or affiliates or authorized agents or
              service provider for normal business purposes, only on need to
              know basis.
            </li>
            <li>
              MMC Convert may be required, from time to time, to disclose the
              Visitor's information to Banks or Payment Services Providers or
              Governmental or judicial bodies or Regulators or any person to
              whom MMC Convert is under an obligation to make disclosure under
              the requirements of any law or terms of service agreement between
              you and MMC Convert. MMC Convert does not release customer
              information except as directed by law or as per your mandate. We
              do not share specific information about customer accounts or other
              personally identifiable data with nonaffiliated third parties for
              their independent use unless:
              <ul>
                <li>
                  The information is provided to help complete a transaction
                  initiated by you.
                </li>
                <li>You request or authorize it.</li>
                <li>The disclosure is required by/or directed by law.</li>
                <li>
                  You have been informed about the possibility of such
                  disclosure for marketing or similar purposes through a prior
                  communication and have been given the opportunity to decline.
                </li>
              </ul>
            </li>
            <li>
              MMC Convert has put in place suitable systems and procedures to
              safeguard and secure the information that it collects online. All
              payments on the Website are <strong>SSL</strong> secured. This means all Personal
              Information you provide on the Website is transmitted using <strong>SSL
              (Secure Socket Layer)</strong> encryption. SSL is a proven coding system
              that lets your browser automatically encrypt, or scramble, data
              before you send it to us.
            </li>
            <li>MMC Convert may also work with third parties for Web traffic analysis to research certain usage and activities on parts of the MMC Convert's website. The Web analysis software is used to find out more about the Visitor, including the Visitor demographics, behavior and usage patterns, for more accurate reporting and to improve the effectiveness of MMC Convert's marketing.</li>
            <li>For data protection, we keep your backup only for 7 days after the completion of conversion. Thus, if you have any queries related to conversion, please get back to us within 7 days, after which we delete your backup from our end.</li>
          </ul>
        </div>
      ),
    },
    {
      title: "Confidentiality and Announcements",
      content: (
        <div>
          <ul>
            <li>
              Neither party may disclose to any person any confidential information disclosed to it by the other party, except as permitted by clause 8.2, unless such information has become public knowledge other than by breach of these Terms.
            </li>
            <li>
              Each party may disclose the other party's confidential information :
              <ul>
                <li>To its employees, officers, agents, consultants or contractors <strong>("Representatives")</strong> who need to know such information for the purposes of carrying out the party's obligations under these Terms, provided that the disclosing party ensures that its Representatives comply with the confidentiality obligations contained in this clause 8 as though they were a party to these Terms; and</li>
                <li>As may be required by law, court order or any governmental or regulatory authority.</li>
              </ul>
            </li>
            
            
          </ul>
        </div>
      ),
    },
    {
      title: "General Terms",
      content: (
        <div>
          <ul>
            <li>
              <strong>Amendments : </strong>We may amend these Terms from time to time by updating our website (but these changes will not apply to orders which were placed prior to the changes).
            </li>
            <li>
              <strong>Law :</strong> These Terms will be governed by the laws of India, and the Indian will have non-exclusive jurisdiction in respect of all matters between you and us.
            </li>
            <li>
              <strong>Assignment and Subcontracting :</strong>Neither party may assign its rights or obligations under these Terms without the consent of the other party (not to be unreasonably withheld or delayed). We may however subcontract any of our obligations, but this will not release us from our obligations to you.
            </li>
            <li>
              <strong>No Agency :</strong>These Terms do not constitute any partnership, trust, agency, joint venture or employment relationship.
            </li>
            <li>
              <strong>Entire Agreement :</strong> These Terms (along with the pricing and Service description on our website, and relevant information on your order form) constitute the entire agreement between you and us, and supersede all previous agreements between you and us relating to this subject matter.
            </li>
            <li>
              <strong>Definitions : In these Terms, the following words have the following special meanings :</strong> 
              <ul>
                <li><strong>"IP"</strong> means all copyright and similar rights (including rights in computer programs, documentation, and drawings), all rights in relation to inventions (including patents and patent applications) and modifications or improvements to the same, registered and unregistered trade marks, registered and unregistered designs, rights in relation to trade secrets, know-how and other confidential information, and all other rights resulting from intellectual activity.</li>
                <li><strong>"Pre-Existing IP"</strong>means any materials (including software, processes and methodologies) of a party in which IP subsists, which are owned by or licensed to that party, and which existed as at the commencement of the provision of Services under these Terms or were developed independently of the performance of these Terms.</li>
                <li><strong>"Product" </strong>means any materials (including software, processes and methodologies) of a party in which IP subsists, which are owned by or licensed to that party, and which existed as at the commencement of the provision of Services under these Terms or were developed independently of the performance of these Terms.</li>
                <li><strong>"Services"</strong>means the data migration services to migrate financial data from one accountancy application to a different accountancy application (as selected by you on the order form), and other associated services, as more particularly described on our website ;</li>
                <li><strong>"Terms" </strong>means these terms and conditions;</li>
                <li><strong>"we", "our",</strong>"us" means M/s MMC Convert and</li>
                <li><strong>"you"</strong> means the customer named in the order form.</li>
              </ul>
            </li>
            
            
          </ul>
        </div>
      ),
    },
  ];

export const policyData: any[] = [
    {
      title: "Who are we?",
      content: (
        <div>
          <p>
            MMC Convert Website{" "}
            <Link to={"https://www.mmcconvert.com"}>
              (https://www.mmcconvert.com)
            </Link>{" "}
            is owned by M/s MMC Convert, an entity registered in India (Entity
            Number 23BCAPM8108A1Z9) and referred to either as MMC, we, our or us
            throughout this policy with registered office at 11/5, SOUTH
            TUKOGANI, Indore, India 452001. We provide data migration service
            from one accounting software to another accounting software
            (referred to as Services throughout this policy) from the following
            website:{" "}
            <Link to={"https://www.mmcconvert.com"}>
              (https://www.mmcconvert.com)
            </Link>{" "}
            (referred to as Website throughout this policy).
          </p>
        </div>
      ),
    },
    {
      title: "Keeping up to date with this Privacy Policy",
      content: (
        <div>
          <p>
            This statement sets out our Privacy Policy and explains what we do
            with the personal information that we collect from our users,
            including any data you may provide through the website when you
            register with us or purchase a Service from us. Please read the
            following to understand our views and practices regarding personal
            information as well as your rights in relation to that information.
            This statement was last updated on 1st April 2023. We reserve the
            right to modify or amend this privacy policy at any time and for any
            reason. It is also important that any data we hold about you is kept
            accurate and up to date so please keep us informed of any changes to
            your personal data whilst using our Services.
          </p>
        </div>
      ),
    },
    {
      title: "What Are Cookies?",
      content: (
        <div>
          <p>
            When accessing our website, MMC shall learn certain information
            about you during your visit. Similar to other commercial websites,
            our website utilises a standard technology called “cookies” (see
            explanation below, “What Are Cookies?”) and web server logs to
            collect information about how our website is used. Information
            gathered through cookies and web server logs may include the date
            and time of visits, the pages viewed, time spent at our website, and
            the websites visited just before and just after our website, your IP
            address.
          </p>
          <p>
            A cookie is a very small text document, which often includes an
            anonymous unique identifier. When you visit a website, that site’s
            computer asks your computer for permission to store this file in a
            part of your hard drive specifically designated for cookies. Each
            website can send its own cookie to your browser if your browser’s
            preferences allow it, but (to protect your privacy) your browser
            only permits a website to access the cookies it has already sent to
            you, not the cookies sent to you by other sites.
          </p>
        </div>
      ),
    },
    {
      title: "IP Addresses",
      content: (
        <div>
          <p>
            IP addresses are used by your computer every time you are connected
            to the Internet. Your IP address is a number that is used by
            computers on the network to identify your computer. IP addresses are
            automatically collected by our web server as part of demographic and
            profile data known as “traffic data”.
          </p>
        </div>
      ),
    },
    {
      title: "Email Information",
      content: (
        <div>
          <p>
            If you choose to communicate with us through email, we may retain
            the content of your email/s together with your email address and our
            responses. We provide the same protections for these electronic
            communications that we employ in the maintenance of information
            received online, mail and telephone.
          </p>
        </div>
      ),
    },
    {
      title: "What information do we collect about you?",
      content: (
        <div>
          <p>
            Personal data, or personal information, is essentially any data that
            could be used to identify a specific, living individual. The
            personal data we collect about you will fall into one of the
            following categories:
          </p>
          <ul>
            <li>
              <strong>Identity information–</strong> information used to ensure
              we can identify the user of our Services which includes your full
              name, a username or other identifier when using our Websites;
            </li>
            <li>
              <strong>Contact information–</strong> information used to ensure
              we can identify the user of our Services which includes your full
              name, a username or other identifier when using our Websites;
            </li>
            <li>
              <strong>Financial and Payment details– </strong> whilst we do not
              collect or store your bank account or payment card details (as
              these are all processed by third party service providers), we do
              retain information about whether you have paid for our Services
              and details of the Services you’ve received so we can correctly
              manage your payments to us. This will all be information that you
              are asked to provide to one of the third party payment service
              providers that we use for this purpose.
            </li>
            <li>
              <strong>Profile and Usage data – </strong>the information about
              how you use our Websites and Services, your preferences in
              relation to the Websites, Services and technology used as well as
              any feedback we receive from you about our Services; and Marketing
              and Communications details – information about how you prefer to
              communicate with us when we are performing our Services for you
              and also how you might wish to hear from us about our other
              Services and Websites.
            </li>
            <li>
              <strong>Any other personal information</strong>that may be required in order to facilitate your dealings with us.
            </li>
          </ul>
        </div>
      ),
    },
    {
      title: "What is Sensitive Information and Does MMC collect Sensitive Information?",
      content: (
        <div>
          <p>Sensitive Information includes information about sexual orientation or religious beliefs. This type of personal information is generally afforded a higher level of protection under the Privacy Act. Sensitive information often includes:</p>
          <ul>
            <li>
              Health
            </li>
            <li>
              Race
            </li>
            <li>
              Political views
            </li>
            <li>
              Religion
            </li>
            <li>
              Sex life
            </li>
            <li>
              Sexual orientation
            </li>
            <li>
              Biometrics
            </li>
            <li>
              Genetics
            </li>
            <li>
              Trade union affiliation
            </li>
          </ul>
          <p>MMC does not collect any sensitive information about you.</p>
        </div>
      ),
    },
    {
      title: "How does MMC collect your personal information?",
      content: (
        <div>
          <p>MMC collects personal information about you through various mechanisms as:</p>
          <ul>
            <li>
              While interacting with us using the Online Chat feature on our website. We ask that you provide your name, email address and telephone number which is stored in our Customer Relations Management software.
            </li>
            <li>
              If you submit a contact us form on our website, you enter your name, email address and telephone number. This information is collected via this form and stored in our Customer Relations Management software,
            </li>
            <li>Information is also collected while using our Sites or Channels, completing our surveys or attending one of our virtual or in-person events.</li>
            <li>In case you send an email to avail a conversion service that information is stored for future communications.</li>
            <li>When you upload your accounting file for us to convert, you supply us with personal details including your name, country, phone number, email, etc. This information is collected via the conversion form, and stored in our Customer Relations Management software. The personal data contained within your file is accessed in order to transfer it from one accounting software to another accounting software.</li>
            <li>We use AWS services to store the data uploaded by the users. We use S3 Bucket functionality created for the respective country from which the data is uploaded by users through the landing page on our website under this bucket.</li>
          </ul>
          <p>We may also collect personal information about you:</p>
          <ul>
            <li>that is publicly available, such as from social media;</li>
            <li>through tools that measure and track how you use a product or service or our Site; and</li>
          </ul>
        </div>
      ),
    },
    {
      title: "How Do We Use the Information That You Provide to Us?",
      content: (
        <div>
          <p>All confidential information and “personal information” shall be used by MMC primarily for the purposes of rendering services pursuant to these Terms and Conditions.</p>
          <p>MMC shall not obtain personally-identifying information about you when you visit our site, unless you choose to provide such information to us, nor will such information be sold or otherwise transferred to third parties.</p>
          <p>We may disclose information when legally compelled to do so, in other words, when we, in good faith, believe that the law requires it or for the protection of our legal rights.</p>
        </div>
      ),
    },
    {
      title: "How Do We Protect Your Information and Secure Information Transmissions",
      content: (
        <div>
         <p>The security of your personal information is at the heart of our business. We understand that you trust us with very important information, and we are committed to protecting it.</p>
         <p>We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so.</p>
         <p>When you share personal information with us, we usually store it in electronic format. We take reasonable steps to protect the personal information you give us from unauthorised access, use or disclosure, in line with industry standards.</p>
         <p>Before providing any information ensure that the website is encrypted and the status bar is “locked”.</p>
         <p>We also ensure to protect all the information that is collected offline in any in-person events.</p>
         <p>In Spite of us taking steps to ensure that your data is protected, please ensure while using our services you are in a secure environment.</p>
        </div>
      ),
    },
    {
      title: "Third party links",
      content: (
        <div>
          <p>Please note that this policy applies only to our website and not to the websites of other organisations to which we may provide links. Clicking on links to other websites may allow third parties to collect or share data about you. We are not responsible for the privacy policies or practices of such third-party sites and you should make your own enquiries in respect of them.</p>
        </div>
      ),
    },
    {
      title: "Changes to the Privacy Policy",
      content: (
        <div>
         <p> case there are any changes to the privacy policies those changes will be updated on the website immediately so keep checking the website for regular updates. In case you want a copy of the latest version, kindly write an email to us at <Link to={'mailto:info@mmcconvert.com'}>info@mmcconvert.com.</Link></p>
        </div>
      ),
    },
    {
      title: "Privacy Policy Complaints and Enquiries",
      content: (
        <div>
         <p>If you have any queries or complaints about our Privacy Policy, please contact us at:</p>
         <p><strong>Email -</strong> <Link to={'mailto:info@mmcconvert.com'}>info@mmcconvert.com.</Link></p>
         <p><strong>Phone -</strong> <Link to={'tel:+919926477000'}>+919926477000</Link></p>
         <p><strong>Physical Address -</strong> 11/5, SOUTH TUKOGANI, Indore, India 452001</p>
        </div>
      ),
    },
  ];